import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';

export default function PrivacyNotice() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="bg-gray-50 rounded-xl p-6 flex items-start space-x-4"
    >
      <Shield className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" />
      <div>
        <h3 className="text-sm font-medium text-gray-900">Privacy Notice</h3>
        <p className="mt-2 text-sm text-gray-600">
          Your privacy is important to us. Any information you provide will be handled in accordance 
          with our privacy policy and will only be used to respond to your inquiry or process your 
          request for information about our programs and services.
        </p>
      </div>
    </motion.div>
  );
}